// Απλή κλάση για παρακολούθηση χρόνου χρήστη
export const UserTimeTracker = {
    // Αποθήκευση του χρόνου εκκίνησης
    startSession: function() {
      window.sessionStartTime = new Date().getTime();
      localStorage.setItem('session_start', window.sessionStartTime);
      
      // Καταγραφή έναρξης συνεδρίας
      window.gtag('event', 'session_start', {
        event_category: 'User Session'
      });
    },
    
    // Καταγραφή επίσκεψης σελίδας
    trackPageView: function(pagePath) {
      window.gtag('config', 'G-P7652J048S', {
        page_path: pagePath
      });
      
      // Αποθήκευση χρόνου έναρξης σελίδας
      this.pageStartTime = new Date().getTime();
    },
    
    // Καταγραφή εξόδου από σελίδα και υπολογισμός χρόνου
    trackPageExit: function(pagePath) {
      if (this.pageStartTime) {
        const timeSpent = Math.round((new Date().getTime() - this.pageStartTime) / 1000);
        
        window.gtag('event', 'time_on_page', {
          event_category: 'User Engagement',
          event_label: pagePath,
          value: timeSpent
        });
      }
    },
    
    // Καταγραφή τέλους συνεδρίας
    endSession: function() {
      const startTime = parseInt(localStorage.getItem('session_start') || new Date().getTime());
      const totalTime = Math.round((new Date().getTime() - startTime) / 1000);
      
      window.gtag('event', 'session_duration', {
        event_category: 'User Session',
        value: totalTime
      });
    }
  };